var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdobeXd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 10.4167C6.25 8.11562 8.11562 6.25 10.4167 6.25H39.5833C41.8844 6.25 43.75 8.11562 43.75 10.4167V39.5833C43.75 41.8844 41.8844 43.75 39.5833 43.75H10.4167C8.11562 43.75 6.25 41.8844 6.25 39.5833V10.4167Z",
    fill: "#FF41C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 9.375V40.625H40.625V9.375H9.375ZM19.8885 22.599L21.8823 17.5125H25.3104L21.8313 24.8573L25.3917 32.324H21.9229L19.8885 27.1458L17.8646 32.324H14.3958L17.9563 24.8573L14.4667 17.5125H17.8948L19.8885 22.599ZM26.1135 26.4854C26.1135 24.6812 26.4187 23.3354 27.0292 22.4469C27.6396 21.5583 28.5271 21.1146 29.6948 21.1146C30.5417 21.1146 31.2479 21.4813 31.8104 22.2135V16.7H34.7094V32.325H32.0948L31.9625 31.2062C31.3729 32.0885 30.6125 32.5292 29.6833 32.5292C28.5312 32.5292 27.651 32.0885 27.0437 31.2062C26.4365 30.324 26.126 29.0292 26.1125 27.3208V26.4854H26.1135ZM29.0031 27.2073C29.0031 28.2927 29.1177 29.051 29.349 29.4812C29.5802 29.9115 29.9698 30.1271 30.5187 30.1271C31.0885 30.1271 31.5187 29.8729 31.8104 29.3646V24.3396C31.526 23.7969 31.0979 23.526 30.5292 23.526C30 23.526 29.6135 23.7396 29.3698 24.1667C29.126 24.5938 29.0031 25.3542 29.0031 26.4458V27.2073Z",
    fill: "#16020B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdobeXd);
export default __webpack_public_path__ + "static/media/adobe-xd.a6dca99dfbbb55b2341d7b1456ca7dcb.svg";
export { ForwardRef as ReactComponent };